<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="entityDetails">
    <table style="width: 100%;">
      <tbody>
        <tr>
          <td class="LayerLine1" nowrap>Entity:</td>
          <td class="LayerData1" nowrap>{{rowData?.ENTITY_NAME}} : {{taxYearBegin}} - {{taxYearEnd}}</td>
          <td class="LayerLine1" nowrap>Business:</td>
          <td class="LayerData1" nowrap>{{rowData?.PARENT_ME_CODE}} - {{rowData?.PARENT_ME}}</td>
          <td class="LayerLine1" nowrap>Tax Code:</td>
          <td class="LayerData1" nowrap>{{rowData?.MARS}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="onTabChange(tab.id)" style="cursor: pointer;" class="btn-sm">{{ tab.name }}</a>
    </li>
}
  </ul>

  <div class="tab-content trial-balance-tab-content">
    @if (activeTab === 0) {
<div class="tab-pane active">
      <gtw-trial-balance-book-adjustment-tab
        [base-urls]="baseUrlsJson"
        [header-data]="headerDataJson"
        [row-data]="rowDataJson"
        [filter-params]="filterParamsJson"
        (request-grid-update)="onChildGridUpdate($event)">
      </gtw-trial-balance-book-adjustment-tab>
    </div>
}

    @if (activeTab === 1) {
<div class="tab-pane active">
      <gtw-trial-balance-repoint-tab
        [base-urls]="baseUrlsJson"
        [header-data]="headerDataJson"
        [row-data]="rowDataJson"
        [filter-params]="filterParamsJson"
        (request-grid-update)="onChildGridUpdate($event)">
      </gtw-trial-balance-repoint-tab>
    </div>
}

    @if (activeTab === 2) {
<div class="tab-pane active">
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader) {
<div class="audit-wrapper">
        <div class="audit-shell">
          <div class="divShadow">
            <div class="table-scroll">
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
                <thead>
                  <tr>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('UPDATED_ON')"></i>Updated On</th>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('REPOINT_DESC')"></i>Repoint Desc</th>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('SYSTEM_ACCT')"></i>System Acct</th>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('AMOUNT')"></i>Amount</th>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('DML_TYPE')"></i>DML Type</th>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('OLD_NEW_FLAG')"></i>Old New Flag</th>
                    <th><i class="fa fa-sort pointer sort-icon" (click)="sortAudit('updated_by')"></i>Updated By</th>
                  </tr>
                </thead>
                @if (!auditRows || auditRows.length === 0) {
<tbody>
                  <tr>
                    <td class="no-data-cell" colspan="7"><b>No Data Available</b></td>
                  </tr>
                </tbody>
}
                @if (auditRows && auditRows.length > 0) {
<tbody>
                  @for (row of auditRows; track $index) {
<tr>
                    <td>{{ row.UPDATED_ON }}</td>
                    <td>{{ row.REPOINT_DESC }}</td>
                    <td>{{ row.SYSTEM_ACCT }}</td>
                    <td class="text-right">{{ row.AMOUNT | number:'1.0-0' }}</td>
                    <td>{{ row.DML_TYPE }}</td>
                    <td>{{ row.OLD_NEW_FLAG }}</td>
                    <td>{{ row.updated_by || row.UPDATED_BY }}</td>
                  </tr>
}
                </tbody>
}
              </table>
            </div>
          </div>
        </div>
      </div>
}
    </div>
}
  </div>
</div>

@if (activeTab === 2) {
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
}
